// @ts-nocheck
export default {
  pt: {
    RECENTLY_SEEN: 'Vistos recentemente',
    YOUR_CART_IS_EMPTY: 'Seu carrinho está vazio',
    YOUR_SHOPPING_CART: 'Seu carrinho de compras',
    ACCUMULATIVE_DISCOUNT: 'Adicione o próximo curso com',
    EXPLORE_THE_CATALOG_AND_START_ADDING_COURES:
      'Explore o catálogo e encontre os melhores cursos para aprender novas habilidades',
    BUY_FOR: 'Comprar por',
    BUY_ALL_FOR: 'Leve tudo por',
    BEST_SELLER_COURSES: 'Cursos mais vendidos',
    ADD_TO_CART: 'Adicionar ao carrinho',
    REMOVE_FROM_CART: 'Retirar do carrinho',
    KEEP_BUYING: 'Seguir comprando',
    BUY_NOW: 'Comprar agora',
    TOTAL: 'Total a pagar',
    TOTAL_IN_CART: 'Subtotal',
    APPLIED_DISCOUNTS: 'Economize',
    APPLIED_CREDITS: 'Créditos disponíveis:',
    SEND_AS_GIFT: 'ENVIAR COMO PRESENTE',
    DELETE: 'Remover',
    RECOMMENDED_COURSES: 'Escolhido especialmente para você',
    AVAILABLE_PAYMENTS: 'Compre com todos os métodos de pagamento disponíveis:',
    WHATSAPP1: 'Têm dúvidas?',
    WHATSAPP2: 'Escreva-nos no whatsapp oi@crehana.com',
    GO_TO_CATALOG: 'Ir para o catálogo',

    YOU_HAVE: 'Você tem',
    IN_YOUR_CART: 'no seu carrinho',
    ACCESS_TO_ALL_COURSES: 'mais acesso a todos os cursos!',
    SUMMARY: 'Resumo',
    GO_PAYMENT_METHODS: 'Outros métodos de pagamento',
  },
};
